<template>
  <div id="app">
    <link rel="apple-touch-icon" href="/logo.png" />
    <router-view></router-view>
  </div>
</template>
<script>
// import { isWechat, wechatShare,  } from "./commJs/wechat";
export default {
  mounted() {},
};
</script>
<style lang="less">
.live-item {
  img {
    width: 100% !important;
    height: auto !important;
  }
}

#app {
  background: #fff;
  // font-family: "方正标雅宋";
  font-family: "思源宋";
  font-weight: normal;
  z-index: "10000";
}

@import "assets/iconfont.css";
.Pageloading {
  text-align: center;
  margin: 40% 0;
}

.line1 {
  height: 5px;
  background: #eaeaea;
  width: 100%;
}

.main {
  padding-bottom: 10px;
  .cards {
    background: #fff;
  }
}

.van-sticky--fixed {
  z-index: 9999999999;
}

body {
  background: #f6f6f6;
}

.loading {
  text-align: center;
  margin: 20px auto;
}

.news-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0;

  .player {
    color: rgb(25, 137, 250);

    .iconfont {
      font-size: 14px;
      color: rgb(25, 137, 250);
      margin-right: 3px;
    }
  }

  &.topic,
  &.bannerImg {
    display: flex;
    flex-direction: column;

    .van-tag {
      background: #e72129;
      position: absolute;
      z-index: 1;
      font-size: 14px;
      height: 25px;
      border-radius: 0;
      left: 3px;
      padding: 0 10px;
      top: 13px;
      line-height: 25px;
    }

    .title {
      font-size: 18px;
      color: #333;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      width: 100%;
      padding: 10px 0;
      font-weight: normal;
    }

    .thumb {
      line-height: 0;
      width: 100% !important;
      aspect-ratio: 2/1 !important;
      .van-image {
        width: 100%;
        border-radius: 3px;
        aspect-ratio: 2/1 !important;

        img {
          border-radius: 3px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }

  &.video {
    .thumb {
      width: 100% !important;
      height: 180px !important;
    }

    .thumb .van-image {
      margin-top: 10px;
      width: 100% !important;
      position: relative;
      height: 180px !important;

      &:before {
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        height: 180px;
        width: 100%;
      }

      &:after {
        content: "\e617";
        position: absolute;
        font-size: 40px;
        font-family: "iconfont" !important;
        top: 50%;
        color: #fff;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  &.moreImg,
  &.video,
  &.bannerImg {
    display: block;

    .right-content {
      width: 100%;
    }

    .info {
      color: #999;
      font-size: 14px;
      display: flex;
      margin-top: 10px;

      span {
        margin-right: 20px;
      }
    }

    .imgList {
      margin-top: 3px;
      display: flex;

      .van-image {
        margin-right: 2px;
        width: 33.33%;
        height: 20vw;
        img {
          object-fit: cover;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .banner {
      .van-image {
        margin-top: 6px;
        width: 100%;
        height: 50vw;
        margin-bottom: -8px;
      }
    }
  }
  .thumb {
    flex-shrink: 0;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .thumb,
  .thumb .van-image {
    width: 120px;
    aspect-ratio: 16/9;
    position: relative;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }

    .iconfont {
      position: absolute;
      z-index: 100;
      left: 50%;
      top: 50%;
      font-size: 26px;
      color: #fff;
      transform: translate(-50%, -50%);
    }
  }

  .right-content {
    position: relative;
    width: calc(100% - 120px);
    display: flex;
    flex-flow: column;
    margin-right: 10px;
    justify-content: space-between;

    .subject {
      font-size: 18px;
      line-height: 28px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      color: #222;
    }

    .simple-desc {
      display: none !important;
      margin: 5px 0;
      line-height: 18px;
      color: #666;
      font-size: 14px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }

    .thread_photo,
    .live_photo {
      background: #1989fa;
      color: #fff;
      padding: 1px 5px;
      font-size: 15px;
      margin-right: 5px;
    }

    .info {
      color: #999;
      font-size: 13px;
      display: flex;
      align-items: center;

      span {
        margin-right: 20px;
      }

      .hot {
        display: flex;
        align-items: center;
        color: #e92129;

        .iconfont {
          margin-left: 10px;
        }
      }
    }
  }
}

.van-swipe__track {
  img {
    border-radius: 0 !important;
  }
}

.van-swipe__indicators {
  bottom: 10px !important;

  .van-swipe__indicator {
    width: 15px !important;
    height: 2px !important;
    border-radius: 0 !important;
  }
}
.van-search {
  padding-bottom: 0 !important;
}
</style>
